import script from "./PoolStatCards.vue?vue&type=script&lang=ts&setup=true"
export * from "./PoolStatCards.vue?vue&type=script&lang=ts&setup=true"

import "./PoolStatCards.vue?vue&type=style&index=0&id=22d1a9ed&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22d1a9ed"]])

export default __exports__